import axios from 'axios';

require('./polyfills/ieJSFix');

window.addEventListener('DOMContentLoaded', () => {
    
    require('./components/modals.js');
    require('./components/header.js');
    require('./components/collections-search.js');
});
